import { render, staticRenderFns } from "./groupsCreate.vue?vue&type=template&id=6fdb4333"
import script from "./groupsCreate.vue?vue&type=script&lang=js"
export * from "./groupsCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports